<template>
	<v-autocomplete
		:rules="rules"
		v-model="innerModel"
		:items="items"
		color="primary"
		:item-text="itemText"
		:item-value="itemValue"
		:label="label"
		outlined
		clearable
	></v-autocomplete>
</template>

<script>
import { FieldRules } from '@/components';

export default {
	name: 'AutoComplete',
	props: {
		value: {},
		items: Array,
		label: {
			type: String,
			required: true,
		},
		itemText: {
			type: String,
			required: true,
		},
		itemValue: {
			type: String,
			required: true,
		},
		isRequired: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		innerModel: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('value', value);
			},
		},
		rules() {
			const rules = [];
			const { selectRequiredValid } = FieldRules;

			if (this.isRequired) {
				const rule = (value) =>
					selectRequiredValid(value) ||
					this.$t('common.required-field-message');
				rules.push(rule);
			}

			return rules;
		},
	},
};
</script>